import { getItem } from '@growth/cookies';

var adobePush = function adobePush(param) {
  if (window) {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(param);
  }
};

var getOmnitureId = function getOmnitureId() {
  return getItem('s_ecid');
};

export { adobePush, getOmnitureId };
